import React, { FC, useContext } from "react";
import { LocalizationContext } from "v3/context/localization";
import {
  StyledOrderProcessing,
  StyledHeadingH1,
  StyledHeadingH2,
  StyledWrapper,
} from "./index.styled";

export const OrderProcessing: FC = () => {
  const { localization } = useContext(LocalizationContext);
  const {
    headingText = "Order Processing",
    subHeadingText = "Your order is being processed. We will send you an email once it is confirmed.",
  } = localization?.components?.orderProcessing || {};

  return (
    <StyledWrapper>
      <StyledOrderProcessing>
        <StyledHeadingH1 level="h1" size="xl">
          {headingText}
        </StyledHeadingH1>
        <StyledHeadingH2 level="h2" size="m">
          {subHeadingText}
        </StyledHeadingH2>
      </StyledOrderProcessing>
    </StyledWrapper>
  );
};
